import { useLayoutEffect } from 'react';
import type { RefObject } from 'react';

export const useHeaderHeight = (ref: RefObject<HTMLElement | null>, isFixed: boolean) => {
    useLayoutEffect(() => {
        const element = ref.current;

        if (!isFixed || !element) {
            document.documentElement.style.setProperty('--nkr-header-height', '0px');
            return;
        }

        const update = () =>
            document.documentElement.style.setProperty(
                '--nkr-header-height',
                (element.offsetHeight - 50) + 'px',
            );

        update();

        const observer = new ResizeObserver(update);

        observer.observe(element);

        return () => observer.disconnect();
    }, [ref, isFixed]);
};

export const useCenterFilterHeight = (ref: RefObject<HTMLElement | null>, isFixed: boolean) => {
    useLayoutEffect(() => {
        const element = ref.current;

        if (!isFixed || !element) {
            document.documentElement.style.setProperty('--nkr-center-filter-height', '0px');
            return;
        }

        const update = () =>
            document.documentElement.style.setProperty(
                '--nkr-center-filter-height',
                element.offsetHeight + 'px',
            );

        update();

        const observer = new ResizeObserver(update);

        observer.observe(element);

        return () => observer.disconnect();
    }, [ref, isFixed]);
};
